import type { Client as WsClient } from "../../../@lib-appsync-ws";
import { useRouteContext } from "./shared/route-context";

export function useWsClient(): WsClient {
	const { wsClient } = useRouteContext();
	return wsClient;
}
